import { getDomain } from "common/common.actions";
import { ICommonState } from "common/common.reducer";
import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { createSelector } from "reselect";
import { IApplicationState } from "../../redux/root-reducer";
import { Role } from "../types";

export interface IProtectedRouteProps extends RouteProps {
  Component: React.ReactNode;
  allowedRoles?: Role[] | undefined;
}

const getStateProps = createSelector(
  (state: IApplicationState) => state.auth,
  (authState) => ({
    isAuthenticated: authState.currentUser !== undefined,
    currentUserRole: authState.currentUser?.role,
    mobileAppUnauthorized: authState.mobileAppUnauthorized,
  })
);

const userHasAnyRole = (
  userIsInRole: Role | undefined,
  allowedRoles: Role[] | undefined
) => {
  if (!allowedRoles || allowedRoles.length === 0) return true;

  if (!userIsInRole) return false;

  return allowedRoles.some((role) => role === userIsInRole);
};

const ProtectedRoute: React.FC<IProtectedRouteProps> = (props) => {
  const { Component, allowedRoles, ...restProps } = props;
  const { isAuthenticated, currentUserRole } = useSelector(getStateProps);
  const { selectedDomain } = useSelector((state: ICommonState) => state);
  const domain = getDomain(selectedDomain);

  const lastUserType = (): Role => {
    const item = localStorage.getItem("wasUserType");
    if (item) {
      return JSON.parse(item) as Role;
    }
    return Role.Landlord;
  };

  return (
    <Route
      {...restProps}
      render={() =>
        isAuthenticated &&
        userHasAnyRole(currentUserRole, allowedRoles) &&
        Component ? (
          Component
        ) : (
          <Redirect
            to={
              lastUserType() === Role.Tenant && domain
                ? {
                    pathname: `/${domain}/login`,
                    state: { from: props.location },
                  }
                : {
                    pathname: "/login",
                    state: { from: props.location },
                  }
            }
          />
        )
      }
    />
  );
};

export default ProtectedRoute;
